import React, { useEffect, useState } from 'react';
import { useAbility } from '@casl/react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import PendingDocuments from '../../../components/Employee/Dashboard/PendingDocuments';
import MyTeamRequests from '../../../components/Employee/Dashboard/MyTeamRequests';
import CompanyTaskDatatable from '../../CompanyTask/CompanyTaskDatatable';
import WorkflowStyledColumns from '../../Dashboard/WorkflowStyledColumns';
import { indexEmployeesRequest, showEmployeeRequest } from '../../../requests/employees';
import PendingRequests from '../../../components/Employee/Dashboard/PendingRequests';
import WorkflowRequestDataTableStyled from '../../WorkflowRequest/WorkflowRequestDataTableStyled';
import TeamAbsencesToday from '../../../components/Employee/Dashboard/TeamAbsencesToday';
import { profileTeamDashboardRequest } from '../../../requests/dashboards';
import TeamAbsenceIndex from '../../Absence/TeamAbsenceIndex';
import { AbilityContext } from '../../../config/abilityContext';
import ShiftAssigmentsCard from '../../../components/Employee/Dashboard/ShiftAssigmentsCard';
import ShiftAssignmentsBossIndex from '../../ShiftAssignments/ShiftAssignmentsBossIndex';
import { HRDashboardStyled, Icon } from '../../../components';
import OvertimeBossNew from '../Overtime/OvertimeBossNew';
import AuthorizeOvertimes from '../Overtime/AuthorizeOvertimes';
import BossDashboardReportsSelector from '../../CompanyReports/BossDashboardReportsSelector';
import ShowReports from './ShowReports';
import VacationBalance from './VacationBalance';
import { sendAlert } from '../../../actions/utils';
import EmployeeVacationTabs from '../../../components/Employee/EmployeeShow/EmployeeVacationTabs';

const TeamDashboardIndex = ({ currentTab, user }) => {
  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);
  const [key, setKey] = useState('requests');
  const [reportKey, setReportKey] = useState('');
  const [employees, setEmployees] = useState([]);
  const [employeeIds, setEmployeeIds] = useState([]);
  const employee = user.employeeCard;
  const currentEmployee = employee.id;
  const [moreData, setMoreData] = useState(false);
  const [cards, setCards] = useState({});
  const [showSpinner, setShowSpinner] = useState(1);
  const [dateRange, setDateRange] = useState([]);
  const [filters, setFilters] = useState({});
  const [showSpinnerToday, setShowSpinnerToday] = useState(true);
  const [successFetchEmployee, setSuccessFetchEmployee] = useState(false);
  const { currentCompany } = useSelector(state => state.auth);
  const { companyModules } = currentCompany;
  const signature = companyModules?.includes('signature');
  const hasRoleShiftAssignment = ability.can('boss', 'ShiftAssignment');
  const hasRoleOvertime = ability.can('boss_create', 'Overtime');
  const hasRoleAuthorizeOverTime = ability.can('authorize', 'Overtime');
  const haveRoleTimeControlReports = ability.can('report', 'TimeControl');
  const [selectedVacationEmployee, setSelectedVacationEmployee] = useState(null);

  const handleVacationEmployeeSelect = employeeId => {
    if (!employeeId) {
      setSelectedVacationEmployee(null);
      setMoreData(prev => !prev);
      return;
    }
    showEmployeeRequest(employeeId, {
      dispatch,
      successCallback: response => {
        const employeeData = camelCaseRecursive(response.data);
        setSelectedVacationEmployee(employeeData);
        setMoreData(!moreData);
      },
      failureCallback: () => {
        dispatch(sendAlert({ kind: 'error', message: 'Colaborador no encontrado' }));
        setSelectedVacationEmployee(null);
        setMoreData(!moreData);
      }
    });
  };

  const fetchEmployees = () => {
    if (currentEmployee) {
      indexEmployeesRequest({
        dispatch,
        params: {
          employees_belong_boss: currentEmployee,
          is_dt: false,
          paginate: false,
          sort_column: 'name',
          sort_direction: 'asc'
        },
        successCallback: res => {
          const ids = [];
          const dataToGroupSearch = [{ id: '', label: 'Todos', value: '' }, ...res.data.data];
          res.data.data.map(item => ids.push(item.id));
          setEmployeeIds(ids.length > 0 ? ids : []);
          setEmployees(dataToGroupSearch);
          setMoreData(!moreData);
          setSuccessFetchEmployee(true);
        }
      });
    }
  };
  useEffect(fetchEmployees, [currentEmployee]);

  const fetchCardData = () => {
    profileTeamDashboardRequest({
      dispatch,
      successCallback: response => {
        setCards(camelCaseEmptyStringRecursive(response.data).allRequestsCount);
        setShowSpinner(0);
      }
    });
  };
  useEffect(fetchCardData, [moreData]);

  const setDatatable = () => {
    switch (key) {
      case 'tasks-datatable':
        return <CompanyTaskDatatable />;
      case 'absences':
        return (
          <TeamAbsenceIndex
            cards={cards}
            currentEmployee={currentEmployee}
            employeesBelongBoss={employeeIds}
            moreData={moreData}
            setMoreData={setMoreData}
          />
        );
      case 'workflows':
        return (
          <WorkflowRequestDataTableStyled
            columns={WorkflowStyledColumns}
            withMassActions
            customFilter={{
              not_document_employee: currentEmployee,
              status: 'pending',
              pending_review: currentEmployee
            }}
            refreshDashboard={() => setMoreData(!moreData)}
            currentTab={currentTab}
          />
        );
      case 'shift_assignments':
        return 'asignaciones de turno';
      default:
        return '';
    }
  };

  const handleReportSelected = params => {
    const selectedKey = params.report_type ? params.report_type.value : '';
    const appliedParams =
      params && Array.isArray(params.employee_ids) && params.employee_ids.length > 0
        ? params
        : { ...params, employee_ids: employeeIds };
    setDateRange(appliedParams.range_date_workday || []);
    setFilters(appliedParams);
    setReportKey(selectedKey);
    setMoreData(true);
  };

  return (
    <>
      <Row className="g-3 g-md-4">
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <PendingRequests cards={cards} handleMoreInfoButton={() => setKey('requests')} showSpinner={showSpinner} />
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <PendingDocuments
            handleMoreInfoButton={() => setKey('workflows')}
            topClass="top-header-green"
            moreData={moreData}
            tab="team"
            signature={signature}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <TeamAbsencesToday
            employeesBelongBoss={employeeIds}
            successFetchEmployee={successFetchEmployee}
            showSpinnerToday={showSpinnerToday}
            setShowSpinnerToday={setShowSpinnerToday}
            handleMoreInfoButton={() => setKey('absences')}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <ShiftAssigmentsCard
            cards={cards}
            handleMoreInfoButton={() => hasRoleShiftAssignment && setKey('shift_assignments')}
            showSpinner={showSpinner}
            hasRoleShiftAssignment={hasRoleShiftAssignment}
          />
        </Col>
      </Row>
      <Row className="g-3 g-md-4">
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative h-100">
          <HRDashboardStyled
            title=""
            label="Saldo Vacaciones"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle=""
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              onClick={() => setKey('vacation_balance')}
              style={{
                border: '1px solid #65b68f',
                backgroundColor: '#65b68f',
                position: 'absolute',
                right: 20,
                bottom: 10
              }}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <HRDashboardStyled
            title=""
            label="Agregar Horas Extras"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle=""
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              onClick={() => hasRoleOvertime && setKey('add_overtime')}
              style={{
                border: hasRoleOvertime ? '1px solid #65b68f' : '1px solid #ccc',
                backgroundColor: hasRoleOvertime ? '#65b68f' : '#ccc',
                position: 'absolute',
                right: 20,
                bottom: 10,
                cursor: hasRoleOvertime ? 'pointer' : 'not-allowed'
              }}
              disabled={!hasRoleOvertime}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <HRDashboardStyled
            title=""
            label="Autorizar Tiempo Extra"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle=""
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              onClick={() => hasRoleAuthorizeOverTime && setKey('authorize_overtime')}
              style={{
                border: hasRoleAuthorizeOverTime ? '1px solid #65b68f' : '1px solid #ccc',
                backgroundColor: hasRoleAuthorizeOverTime ? '#65b68f' : '#ccc',
                position: 'absolute',
                right: 20,
                bottom: 10,
                cursor: hasRoleAuthorizeOverTime ? 'pointer' : 'not-allowed'
              }}
              disabled={!hasRoleAuthorizeOverTime}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <HRDashboardStyled
            title=""
            label="Reportes Control del Tiempo"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle=""
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              onClick={() => haveRoleTimeControlReports && setKey('ct_reports')}
              style={{
                border: haveRoleTimeControlReports ? '1px solid #65b68f' : '1px solid #ccc',
                backgroundColor: haveRoleTimeControlReports ? '#65b68f' : '#ccc',
                position: 'absolute',
                right: 20,
                bottom: 10,
                cursor: haveRoleTimeControlReports ? 'pointer' : 'not-allowed'
              }}
              disabled={!haveRoleTimeControlReports}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </Col>
        <Col xs={12} sm={6} md={3} xl={3} className="mb-1 mt-2 position-relative h-100">
          <HRDashboardStyled
            title=""
            label="DNC"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle=""
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              // onClick={handleMoreInfoButton}
              style={{
                border: '1px solid #65b68f',
                backgroundColor: '#65b68f',
                position: 'absolute',
                right: 20,
                bottom: 10
              }}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </Col>
      </Row>
      {key === 'requests' && (
        <Row>
          <Col sm={12} className="mb-1">
            <MyTeamRequests
              cards={cards}
              currentEmployee={currentEmployee}
              employeesBelongBoss={employeeIds}
              moreData={moreData}
              setMoreData={setMoreData}
            />
          </Col>
        </Row>
      )}
      {key === 'workflows' && (
        <Card className="mb-1">
          <Col className="top-header-green">
            <Col className="card-header-title">Gestión de Documentos</Col>
          </Col>
          <Col sm={12} md={12} lg={12}>
            {setDatatable(key)}
          </Col>
        </Card>
      )}

      {key === 'absences' && setDatatable(key)}

      {key === 'shift_assignments' && (
        <Card className="mb-1">
          <Col className="top-header-green">
            <Col className="card-header-title">Asignación de Turnos</Col>
          </Col>
          <Col sm={12} md={12} lg={12}>
            <ShiftAssignmentsBossIndex rrhh={false} showTitle={false} currentEmployee={currentEmployee} />
          </Col>
        </Card>
      )}

      {key === 'add_overtime' && (
        <Card className="mb-1">
          <Col className="top-header-green">
            <Col className="card-header-title">Agregar Horas Extras</Col>
          </Col>
          <Col sm={12} md={12} lg={12} className="mt-2">
            <OvertimeBossNew />
          </Col>
        </Card>
      )}
      {key === 'authorize_overtime' && (
        <Card className="mb-1">
          <Col className="top-header-green">
            <Col className="card-header-title">Autorizar Tiempo Extra</Col>
          </Col>
          <Col sm={12} md={12} lg={12} className="mt-2">
            <AuthorizeOvertimes />
          </Col>
        </Card>
      )}
      {key === 'ct_reports' && (
        <>
          <Card className="mb-1">
            <Col className="top-header-green">
              <Col className="card-header-title">Reportes Control del Tiempo</Col>
            </Col>
            <Col sm={12} md={12} lg={12} className="mt-2">
              <BossDashboardReportsSelector
                ability={ability}
                employees={employees}
                formRequest={handleReportSelected}
                employeeIds={employeeIds}
                successFetchEmployee={successFetchEmployee}
              />
            </Col>
          </Card>
          {reportKey !== '' && (
            <ShowReports
              moreData={moreData}
              setMoreData={setMoreData}
              filters={filters}
              dateRange={dateRange}
              reportKey={reportKey}
            />
          )}
        </>
      )}

      {key === 'vacation_balance' && (
        <Card className="mb-1">
          <Col className="top-header-green">
            <Col className="card-header-title">Saldo Vacaciones</Col>
          </Col>
          <Col sm={12} md={12} lg={12} className="mt-2">
            <VacationBalance
              employees={employees}
              successFetchEmployee={successFetchEmployee}
              onSelectEmployee={handleVacationEmployeeSelect}
            />

            {selectedVacationEmployee && (
              <div className="mt-2">
                <p>Saldo de Vacaciones de {selectedVacationEmployee.fullName}</p>
                <EmployeeVacationTabs
                  employee={selectedVacationEmployee}
                  showButton={false}
                  moreData={moreData}
                  setMoreData={setMoreData}
                  withDefaultDates
                />
              </div>
            )}
          </Col>
        </Card>
      )}
    </>
  );
};

export default TeamDashboardIndex;
